// removed by extract-text-webpack-plugin
module.exports = {"Card":"src-components-Card----Card-module---Card---VK6eT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/Card.module.css
// module id = 133
// module chunks = 35783957827783 212839066777427